export function parseError(error: unknown) {
  const message = typeof error === 'object' && error != null && 'message' in error && typeof error.message === 'string' ? error.message : 'Unknown error'
  const status =
    typeof error === 'object' && error != null && 'status' in error && (typeof error.status === 'number' || typeof error.status === 'string')
      ? error.status
      : 'Unknown status'
  return { message, status }
}

/**
 * Type guard to check if a value is an instance of Error.
 * @param error - The value to check.
 * @returns True if the value is an Error instance, otherwise false.
 */
export function isError(error: unknown): error is Error {
  return error instanceof Error
}

export class S3UploadError extends Error {
  status?: number

  constructor(message: string, code?: number) {
    super(message)
    this.name = 'S3UploadError'
    this.status = code
  }
}
